import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/terms/page.js");
